import React from 'react';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';
import AUIIcon from '@ancert/aui-icon';
import AUIButton from '@ancert/aui-button';
import { ROUTES } from '../../constants';

const NotificationContainer = ({ icon, iconColor, title, description }) => {
  const history = useHistory();

  return (
    <div className="c-sii-notification-container">
      <AUIIcon icon={icon} size="xxl" color={iconColor} />
      <h1 className="c-sii-notification-container__titl u-mt-8">{title}</h1>
      <p className="c-sii-notification-container__desc u-mt-8">{description}</p>
      <AUIButton
        className="c-sii-notification-container__button u-mt-24"
        label="Volver al inicio"
        mode="secondary"
        size="lg"
        onClick={() => {
          history.push(ROUTES.HOME);
        }}
      />
    </div>
  );
};
NotificationContainer.propTypes = {
  icon: string,
  iconColor: string,
  title: string,
  description: string,
};
NotificationContainer.defaultProps = {
  icon: string,
  iconColor: string,
  title: string,
  description: string,
};

export default NotificationContainer;
